import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingCounterService } from '../services/loading/loading-counter.service';
import { BcLoadingService } from '../services/commons/bc-loading/bc-loading.service';

const SKIP_HEADER = 'X-Skip-Loader';

@Injectable()
export class GlobalLoaderInterceptor implements HttpInterceptor {
  private closeTimer: any = null;
  private openedAt = 0;
  private readonly minVisibleMs = 300;
  private visible = false;

  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has(SKIP_HEADER)) {
      return next.handle(req.clone({ headers: req.headers.delete(SKIP_HEADER) }));
    }

    const counter = this.injector.get(LoadingCounterService);
    const loader = this.injector.get(BcLoadingService);

    this.clearCloseTimer();

    const active = counter.inc();
    this.showLoaderIfNeeded(active, loader);

    return next.handle(req).pipe(finalize(() => this.handleFinalize(counter, loader)));
  }

  private clearCloseTimer(): void {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  }

  private showLoaderIfNeeded(active: number, loader: BcLoadingService): void {
    if (active === 1 && !this.visible) {
      requestAnimationFrame(() => {
        this.visible = true;
        this.openedAt = Date.now();
        loader.show();
      });
    }
  }

  private handleFinalize(counter: LoadingCounterService, loader: BcLoadingService): void {
    const remaining = counter.dec();
    if (remaining > 0) {return};

    const elapsed = Date.now() - this.openedAt;
    const wait = Math.max(0, this.minVisibleMs - elapsed);

    this.closeTimer = setTimeout(() => {
      if (counter.value === 0 && this.visible) {
        this.visible = false;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => loader.close());
        });
      }
      this.closeTimer = null;
    }, wait);
  }
}
